module.exports = __webpack_public_path__ + "static/media/Illus-Credit_2@3x.d9c7d689.png";